import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { MenuInsturenScherm } from './menu/MenuInsturenScherm.js';
import './index.css';

const wortel = document.getElementById('root');
if (wortel === null) {
  throw new Error('Kan het dashboard niet starten: #root ontbreekt in index.html');
}

// De kraam heeft geen account. Hij krijgt een link naar #menu en typt daar de
// code van het kaartje in; dat scherm staat dus helemaal buiten het inloggen.
const kraamStuurtMenuIn = window.location.hash === '#menu';

createRoot(wortel).render(
  <StrictMode>{kraamStuurtMenuIn ? <MenuInsturenScherm /> : <App />}</StrictMode>,
);
